/* eslint-disable @tencent/i18next/no-literal-string */
import { network } from '@tencent/netcheck';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import { UPLOAD_PICTURE_OCR_ID } from '@framework/editor/src/js/constants/index';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { AddonIframeOptions } from './configure/addon-iframe.interface';
import AddonIframe from './configure/addon-iframe';
import { Addon } from './configure/addon-formula';
import { transaction } from '@src/slide/domain/slide-app';
import _has from 'lodash/has';
import _get from 'lodash/get';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import ToolbarManager from '@framework/editor/src/js/constants/toolbar-data';
// 上报相关
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import CommonTips from '@com/common-tips';
import i18n from '@i18next/i18n';
import { getParamFromUrl } from './utils';
import { getAddonScaleViewUniqueName } from '@editor/src/page/index/components/canvas/element-types/shape-element/addon/utils';
import { blobToBase64 } from '@src/slide/infrastructure/module/dependent/image/upload';
import DUILoading from '@tencent/dui/lib/components/Loading';
import { ADDON_TYPE, DEFAULT_MIMETYPE } from '@src/js/constant';
import ImageUrl from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-url';
import { isEmptyText } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/utils/text-util';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import { ADDON_ID_FORMULA } from './addon-constants';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { deepCopy } from '@src/slide/infrastructure/module/independent/object-operation';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { AddonManagerEventsKeys, AddonManagerEventsMap, IAddonManager, IAddonSdkApi } from './addon-manager.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import axios from 'axios';
import { generateFailImageUrl } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/fill-style/image-cache/fail-image';
import { IAddonHandler } from './addon-handler.interface';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IImageSdkData, IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { IAddonHandlerMobile } from './addon-handler-mobile.interface';
import { ICopyPaste, ICopyPasteImageService } from '@src/slide/application/service/copy-paste/copy-paste.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { ILinkManager } from '@src/slide/application/service/link-manager/core/link-manager.interface';
import { INativeTitleBarManager } from '@src/slide/application/service/native-titlebar-manager/core/interface';
import { IFormulaOcrManager } from '@src/slide/application/service/formula-ocr-manager/core/interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import {
    ISlideRenderStateManager, IStatePointEnum,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

declare global {
    interface Window {
        log: any;
    }
}
enum ToolbarButtonType {
    FULLSCREEN = 'fullscreen',
}

type processParagraphList = (paragraphList: IParagraph[]) => any[];

export default class AddonManager implements IAddonManager {
    public event: IEventEmitter<AddonManagerEventsMap>;
    public addonHandler: IAddonHandler | IAddonHandlerMobile;
    public workbenchLoaded = false;
    private addonIframe: AddonIframe;
    private model: any;
    private visibleSlides: Array<string>;
    private updatedSlideSet: Set<string>;
    private iframeInfo: AddonIframeOptions;
    private activeElementCallbackMap: Map<any, any>;
    private linkManager?: ILinkManager;
    private copyPasteManager?: IDynamicService<ICopyPaste>;
    private copyPasteImageService?: IDynamicService<ICopyPasteImageService>;
    private formulaOcrManager?: IDynamicService<IFormulaOcrManager>;
    private uiDataService: IUiDataService;
    private nativeTitleBarManager?: INativeTitleBarManager;
    private menuManager?: IMenuManager;

    public constructor(
        private slideRenderStateManager: ISlideRenderStateManager,
        private selectionService: ISelectionService,
    ) {
        this.event = new EventBus();
        slideRenderStateManager.getStatePoints()[IStatePointEnum.visibleSlideRender].getPointCompletePromise()
            .then(() => {
                if (browser.isMobile) {
                    import(/* webpackChunkName: "addonHandler" */ './addon-handler-mobile').then((module) => {
                        const api: IAddonSdkApi = {
                            event: this.event,
                            refreshIframe: this.refreshIframe,
                            updateToolbar: this.updateToolbar,
                            uploadPictureFormulaOcr: this.uploadPictureFormulaOcr,
                        };
                        const AddonHandler = module.default;
                        this.addonHandler = new AddonHandler(
                            api, this,
                            selectionService, this.getNativeTitlebarManager,
                        );
                        this.event.emit(AddonManagerEventsKeys.ADDON_HANDLER_IMPORT_READY);
                    })
                        .catch((err) => {
                            window.log.error(`[loadChunk-error]${err}`);
                        });
                } else {
                    import(/* webpackChunkName: "addonHandler" */ './addon-handler').then((module) => {
                        const api: any = {
                            event: this.event,
                            refreshIframe: this.refreshIframe,
                            updateToolbar: this.updateToolbar,
                            uploadPictureFormulaOcr: this.uploadPictureFormulaOcr,
                        };
                        const AddonHandler = module.default;
                        this.addonHandler = new AddonHandler(api, this, selectionService, this.linkManager);
                        this.event.emit(AddonManagerEventsKeys.ADDON_HANDLER_IMPORT_READY);
                    })
                        .catch((err) => {
                            window.log.error(`[loadChunk-error]${err}`);
                        });
                }
            });
        this.model = null;
        this.visibleSlides = [];
        this.updatedSlideSet = new Set();
        this.activeElementCallbackMap = new Map();

        // 网络错误
        this.event.on(AddonManagerEventsKeys.ERROR_NETWORK, () => {
            CommonTips.getInstance().show({
                message: i18n.t('网络已断开，请稍后再试'),
                autoClose: true,
                block: false,
            });
        });
        eventBus.on(EventKeys.WORKBENCH_IS_MOUNT, () => this.workbenchLoaded = true);
    }
    public setVisibleSlide(ids: Array<string>) {
        this.visibleSlides = ids;
    }
    public updateViewSlide() {
        this.visibleSlides.forEach((id) => {
            // 更新可视范围内，页面的所有占位图= =
            this.updateSlideAddonScaleView(id);
        });
    }
    public updateSlideAddonScaleView(id: string) {
        // 找出key对应的slide
        const slides = this.selectionService?.slides.filter(s => s.id === id);
        // 避免重复更新
        if (this.updatedSlideSet.has(id)) return;
        slides?.[0].children.forEach((shapeModel) => {
            if (isIframeShapeModel(shapeModel)) {
                this.updateCachedElement(shapeModel);
            }
        });
        // slide更新完，标注一下
        this.updatedSlideSet.add(id);
    }
    // 从浏览态切换到编辑态 重制标志状态
    public resetSlideUpdateState = () => {
        this.updatedSlideSet.clear();
    };
    public savePrevShapeModel(model, callback) {
        this.model = model;
        if (callback) {
            this.activeElementCallbackMap.set(this.model, callback);
        }
    }
    public updateShapeModel(model?) {
        if (this.model) {
            // 存在之前的model 先改为占位图
            this.updateCachedElement(this.model);
            this.model = null;
        }
        if (model) {
            // 有model参数，代表有新的iframe被点击到 需要激活
            this.updateCachedElement(model);
            this.model = model;
        }
    }
    public updateCachedElement = (model) => {
        const callback = this.activeElementCallbackMap.get(model);
        callback?.();
        this.activeElementCallbackMap.delete(model);
    };

    public updateIframeCloneDomStyle = (iframeWrapper) => {
        // iframe元素存在时，remove掉
        const iframe = iframeWrapper.querySelector('iframe');
        iframe && iframeWrapper.removeChild(iframe);

        // 占位图元素改为显示
        const scaleView = iframeWrapper.querySelector(`#${getAddonScaleViewUniqueName()}`);
        scaleView.style.display = 'block';

        // 如果是小程序，还需要去掉clone元素的banner...
        const scaleViewBanner = iframeWrapper.querySelector(`#${getAddonScaleViewUniqueName()}-banner`);
        if (scaleViewBanner) {
            scaleViewBanner.style.display = 'none';
        }
        // 去掉scale-slide中的文案
        const pTextList = scaleView.querySelectorAll('p');
        if (pTextList.length > 0) {
            pTextList.forEach((pText) => {
                // eslint-disable-next-line no-param-reassign
                pText.style.display = 'none';
            });
        }

        const loading = iframeWrapper.querySelector('#addon-loading');
        loading.style.display = 'none';
    };

    public updateToolbar = (toolbarData: string, entryPos: string) => {
        if (!this.menuManager) return;
        this.menuManager.asyncMenuItemReady = false;

        if (entryPos === ADDON_TYPE.INSERT) {
            ToolbarManager.updateAddonList(toolbarData);
            this.menuManager.asyncMenuItemReady = true;
        }

        if (entryPos === ADDON_TYPE.FORMULA) {
            ToolbarManager.updateAddonFormula(toolbarData);
            this.menuManager.asyncMenuItemReady = true;
        }

        if (entryPos === ADDON_TYPE.UNOFFICIAL) {
            // 非官方插件置于 `智能工具` 菜单中
            ToolbarManager.updateAddonUnOfficial(toolbarData);
            this.menuManager.asyncMenuItemReady = true;
        }
    };

    public async checkLink(link) {
        if (!this.addonHandler || !browser.isPc) {
            return false;
        }
        const supportedAddons: any[] = [];
        this.addonHandler.addonInfoMap.forEach((info) => {
            const { domains } = info.config;
            const { isOfficial } = info;
            const idx = domains?.findIndex(({ domain = '' }) => {
                const regex = new RegExp(domain.replace(/\*/g, '[^ ]*'));
                return regex.test(link);
            });
            // domain的校验只针对官方插件
            if (idx >= 0 || !isOfficial) {
                supportedAddons.push((info as any).aid);
            }
        });
        if (supportedAddons.length > 0) {
            this.iframeInfo = await (this.addonHandler as IAddonHandler).parseLinkAsAddon(link);
            if (this.iframeInfo) {
                return true;
            }
        }
        return false;
    }

    /**
     * 根据插件 aid 和 menu id 获取 menu 的 report id
     * @param aid
     * @param id
     */
    public getAddonReportId = (aid, id) => {
        let reportId = '';
        this.addonHandler.addonMetaMap.get(aid)?.config?.menus?.forEach((item) => {
            if (item.id === id) {
                reportId = item.report_id;
            }
        });
        return reportId;
    };

    /**
     * 根据插件 aid 和 menu id 获取 menu 的 name
     * @param aid
     * @param id
     */
    public getAddonReportName = (aid, id) => {
        const temp = this.addonHandler.addonMetaMap.get(aid)?.config?.menus?.find(item => item.id === id);
        return temp?.name;
    };

    /**
     * 根据插件 aid 和品类的额外信息，动态获取全屏配置
     * @param aid
     * @param extraData
     */
    public getAddonFullScreenTitle = (aid, extraData) => {
        const addonMenus = this.addonHandler.addonMetaMap.get(aid)?.config?.menus;
        if (!addonMenus?.length) {
            return '';
        }
        // 部分插件没有 extraData
        if (!extraData) {
            return addonMenus[0]?.name || '';
        }
        try {
            // 避免 extraData 数据不规范导致 crash
            const { type } = JSON.parse(extraData);
            return addonMenus.find(item => getParamFromUrl(item.page, 'type') === type)?.name || '';
        } catch (err) {
            console.error(err);
            return '';
        }
    };

    public async shouldRenderFullScreenItem(aid, extraData) {
        if (!browser.isPc) {
            return;
        }
        const buttons = await (this.addonHandler as IAddonHandler)?.
            emitMessageToAddon?.('$onLoadToolbarButtons', { extraData }, aid) as ToolbarButtonType[];
        if (!buttons) {
            return false;
        }
        return buttons.indexOf(ToolbarButtonType.FULLSCREEN) !== -1;
    }

    public getIframeInfo = () => ({
        iframeId: this.iframeInfo?.aid,
        embedUrl: this.iframeInfo?.embedUrl,
        extraData: this.iframeInfo?.extraData,
    });

    /**
     * 插入iframe元素
     * @param iframeInfos
     */
    // eslint-disable-next-line complexity
    public insertIframeContainer = (iframeInfos: AddonIframeOptions) => {
        if (!this.canAddIframeElement()) {
            return;
        }

        this.selectionService?.selectedElements.clear();

        const {
            title, embedUrl, originUrl, aid, extraData, mode, docElement,
        } = iframeInfos;

        // 插入元素的尺寸不应该大于画布
        let {
            width = 1,
            height = 1,
        } = iframeInfos;
        const eleRadio = width / height;

        const { slideWidth } = this.uiDataService.presentation.props;
        if (width > slideWidth) {
            width = slideWidth;
            height = width / eleRadio;
        }

        this.addonIframe = new AddonIframe(
            title ?? '', embedUrl ?? '', originUrl ?? '', aid ?? '',
            width, height, extraData, mode, docElement,
        );
        this.addonIframe.setUiDataService(this.uiDataService);

        const slideModel = this.selectionService?.currentSlide;
        if (!slideModel) {
            return;
        }
        const text = (iframeInfos.title && iframeInfos.title.length > 0) ? iframeInfos.title : iframeInfos.originUrl;
        // 在文本框中插入文字链
        const paragraphList = [
            {
                textRuns: [{
                    styles: {
                        href: {
                            url: iframeInfos.originUrl,
                        },
                        ['raw-href']: true,
                    },
                    text,
                }],
            },
        ];

        slideModel.addElementWithParagraphList(this.addonIframe.getAddonIframeProps(), paragraphList);
    };

    public canAddIframeElement = (count = 1) => {
        const slideModel = this.selectionService?.currentSlide;
        if (!slideModel) {
            return;
        }
        const iframeList = slideModel.children
            .filter(element => isIframeShapeModel(element));
        if (iframeList.length + count > 3) {
            Snackbar.show({
                message: '插入第三方内容数量上限为3个',
                type: 'info',
                autoClose: true,
            });
            return false;
        }
        return true;
    };

    public refreshIframe = (srcUrl?: string, embedUrl?: string, displayText?: string) => {
        const model = this.selectionService?.getSelectedModel();
        const url = srcUrl ? srcUrl : _get(model, 'props.addon.originUrl');
        const newEmbedUrl = embedUrl ? embedUrl : _get(model, 'props.addon.embedUrl');
        const title = displayText ? displayText : _get(model, 'props.addon.title');
        const text = title ? title : url;
        const updateProps = {
            addon: {
                docElement: {
                    originURL: url,
                    embedURL: newEmbedUrl,
                },
                originUrl: url,
                embedUrl: newEmbedUrl,
                title,
            },
        };
        const paragraphList = [{
            textRuns: [{
                styles: {
                    href: {
                        url,
                    },
                    ['raw-href']: true,
                },
                text,
            }],
        }];
        transaction(() => {
            if (model) {
                (model as any).updateParagraphList?.(paragraphList);
                (model as any).updateAndRemoveProps?.(updateProps);
            }
        });
    };

    /**
     * 文字链<-->卡片态 切换
     * @param model
     * @param toMode
     * @param linkData
     * @param textPositionInfo
     */
    public changeIframeMode(model, toMode, linkData?, textPositionInfo?, processParagraphList?: processParagraphList) {
        const fromMode = _has(model, 'props.addon.displayMode') ? model.props.addon.displayMode : AddonMode.NORMAL;
        if (fromMode === toMode) {
            return;
        }
        if (fromMode === AddonMode.IFRAME) {
            // 切换为文字链
            this.changeIframeToLink(model, toMode);
        } else if (fromMode === AddonMode.NORMAL) {
            // 切换为卡片态
            if (toMode === AddonMode.IFRAME) {
                this.changeLinkToIframe(model, linkData, textPositionInfo, processParagraphList);
            }
        }
    }

    /**
     * 插件调用的插入图片接口，目前可能为公式图片或者普通图片
     * @param imageAddonElement 插件返回的图片数据
     */
    public insertAddonPicture = (imageAddonElement) => {
        const { selectedModel, imageSdkData } = this.getImageData(imageAddonElement);

        if (selectedModel?.type === UIModelType.SHAPE && (selectedModel as IShapeModel)?.isTextMath) {
            // 删除原有office公式图片，插入新的公式图片
            const { selectionService } = this;
            if (!selectionService) return;
            const { currentSlideIndex } = selectionService;
            if (currentSlideIndex === -1) return;
            const slideModel = selectionService.slides[currentSlideIndex];
            if (slideModel) {
                // 转换图片宽高计算单位：像素距离 => dom距离
                const imageCanvas = {
                    width: ptToCanvas(imageSdkData.width),
                    height: ptToCanvas(imageSdkData.height),
                };

                // 获取frame外框的宽、高和position的left、top位置
                const {
                    width: frameWidth,
                    height: frameHeight,
                    left: frameLeft,
                    top: frameTop,
                } = (selectedModel as IElementBaseModel).props.style;

                // frame外框的中心点坐标
                const frameCenterCoordinates = {
                    x: frameLeft + (frameWidth / 2),
                    y: frameTop + (frameHeight / 2),
                };

                const aExtraProps = {
                    src: imageSdkData.src,
                    addon: imageSdkData.addon,
                    style: {
                        alpha: 1,
                        srcRect: { l: 0, r: 0, t: 0, b: 0 },
                        width: imageCanvas.width,
                        height: imageCanvas.height,
                        left: frameCenterCoordinates.x - (imageCanvas.width / 2),
                        top: frameCenterCoordinates.y - (imageCanvas.height / 2),
                    },
                };
                transaction(() => {
                    slideModel.deleteElement([selectedModel]);
                    slideModel.addElement(UIModelType.IMAGE, aExtraProps);
                    // 比较hack的做法，addElement被transaction时不知为何会选中两次，手动clear一次
                    selectionService?.selectedElements.clear();
                });
            }
        } else {
            // 侧边栏中的图片相关的插件点击插入后会将焦点放到iframe中，手动失焦以保证此时的快捷键操作
            (document.activeElement as HTMLElement)?.blur?.();
            if (this.isGifUrl(imageSdkData.src)) {
                this.addFirstFrameForGif(imageSdkData);
            } else {
                this.addNewPicture(imageSdkData);
            }
        }
    };

    /**
     * 插件调用的更新图片接口，目前只为公式图片
     * @param imageAddonElement 插件返回的图片数据
     */
    public updateAddonPicture = async (imageAddonElement) => {
        // 获取当前选中元素的状态
        const { selectedModel, imageSdkData } = this.getImageData(imageAddonElement);
        if (selectedModel?.type === UIModelType.IMAGE) {
            const { ImageEditManager } = await this.copyPasteImageService?.promise() ?? {};
            const copyPasteManager = await this.copyPasteManager?.promise();
            const imageManager = ImageEditManager?.getInstance();

            if (imageManager) {
                imageManager.imageReplaceAction = 1; // 替换图片
                imageManager.clipDataWaiting = false; // 不等待剪切板
            }

            // 编辑/替换图片
            const { addon } = imageSdkData;
            if (// 图片数据为公式图片
                addon?.type === 'latex'
                // 替换前景图片
                && copyPasteManager?.imageEditManager.imageReplaceAction === 1
            ) {
                // 触发替换公式图片的处理方法
                (selectedModel as IPictureModel).updateLatex(imageSdkData);
            } else {
                if (copyPasteManager) {
                    // 清除状态
                    copyPasteManager.imageEditManager.imageReplaceAction = 0;
                }
            }

            // 上报：成功编辑并插入Latex公式
            tdw({
                opername: TDWOperationType.DOC_FORMULA,
                module: TDWModuleType.FORMULA_RE_EDITED,
                action: TDWActionType.FORMULA_INSERT,
            });
        }
    };

    public uploadPictureFormulaOcr = () => new Promise<string>((resolve, reject) => {
        const input = document.getElementById(UPLOAD_PICTURE_OCR_ID);

        // 监听图片上传
        input?.addEventListener('change', async ({ target }) => {
            const targetDom = target as any;

            if (!network.isOnline) {
                this.event.emit(AddonManagerEventsKeys.ERROR_NETWORK);
                targetDom.value = '';
                return;
            }

            if (!this.formulaOcrManager) return;

            // 开始识别，弹出loading
            const loading = DUILoading.show({ tip: i18n.t('正在识别公式...'), zIndex: 11001 });

            const dataURL = await blobToBase64(targetDom.files![0]);
            targetDom.value = '';
            const { formulaOCR } = await this.formulaOcrManager.promise();
            const formulaText = await formulaOCR(dataURL);
            loading.close();

            if (typeof formulaText === 'string' && formulaText) {
                // 有ocr识别结果，正常执行
                resolve(formulaText);
                return formulaText;
            }
            // 提示识别失败
            CommonTips.getInstance().show({
                message: i18n.t('无法识别公式，请重试。'),
                autoClose: true,
                block: false,
            });

            // 没有ocr识别结果，提示识别失败
            reject(null);
            return null;
        }, { once: true });
        input?.click();
    });

    public setMenuManagerDelegate(menuManager: IMenuManager) {
        if (this.menuManager) return;
        this.menuManager = menuManager;
    }

    public setCopyPasteManager(copyPasteManager: IDynamicService<ICopyPaste>) {
        if (this.copyPasteManager) return;
        this.copyPasteManager = copyPasteManager;
    }

    public setCopyPasteImageService(copyPasteImageService: IDynamicService<ICopyPasteImageService>) {
        if (this.copyPasteImageService) return;
        this.copyPasteImageService = copyPasteImageService;
    }

    public setNativeTitlebarManager(nativeTitleBarManager: INativeTitleBarManager) {
        if (this.nativeTitleBarManager) return;
        this.nativeTitleBarManager = nativeTitleBarManager;
    }

    public setSelectionService(selectionService: ISelectionService) {
        if (this.selectionService) return;
        this.selectionService = selectionService;
    }

    public setFormulaOcrManager(formulaOcrManager: IDynamicService<IFormulaOcrManager>) {
        if (this.formulaOcrManager) return;
        this.formulaOcrManager = formulaOcrManager;
    }

    public setUiDataService(uiDataService: IUiDataService) {
        if (this.uiDataService) return;
        this.uiDataService = uiDataService;
    }

    public setLinkManager(linkManager: ILinkManager) {
        if (!this.linkManager) {
            this.linkManager = linkManager;
        }
    }

    private async addNewPicture(imageSdkData: IImageSdkData) {
        // 插入图片
        const copyPasteImageService = await this.copyPasteImageService?.promise();
        copyPasteImageService
            ?.addImagesInSlide([imageSdkData], this.selectionService?.slides[this.selectionService.currentSlideIndex]);
        const selection = this.selectionService;
        if (selection) {
            selection.lastMouseDownRegion = RegionType.EDITOR;
        }

        // 上报：成功新建并插入Latex公式
        tdw({
            opername: TDWOperationType.DOC_FORMULA,
            module: TDWModuleType.FORMULA_NEW,
            action: TDWActionType.FORMULA_INSERT,
        });
    }

    private isGifUrl(srcUrl: string): boolean {
        return srcUrl.indexOf('gif') > -1;
    }

    private addFirstFrameForGif(imageSdkData: IImageSdkData) {
        const [pureUrl] = imageSdkData.src.split('?');
        const url = `${pureUrl}?imageInfo`;
        axios({
            method: 'get',
            url,
            timeout: 2000,
        }).then((response) => {
            if (response.status === 200) {
                const { data } = response;
                const width = Number(data.width);
                const height = Number(data.height);
                const frameCount = Number(data.frame_count);
                const size = width * height * frameCount;
                // 超过2.5亿像素转换会失败
                if (size < 2.5e8) {
                    imageSdkData.backupSrc = `${imageSdkData.src}&imageMogr2/format/jpg/ignore-error/1`;
                } else {
                    const { width: imageWidth, height: imageHeight } = imageSdkData;
                    imageSdkData.backupSrc = generateFailImageUrl(i18n.t('图片上传失败，请稍后再试。'), imageWidth, imageHeight);
                }
            } else {
                const { width, height } = imageSdkData;
                imageSdkData.backupSrc = generateFailImageUrl(i18n.t('图片上传失败，请稍后再试。'), width, height);
            }
            this.addNewPicture(imageSdkData);
        });
    }

    private getImageData(imageAddonElement) {
        const selectedModel = this.selectionService?.getSelectedModel();
        let addonType = imageAddonElement.sourceType;

        if (
            config.supportEnterprise(EnterPriseType.ALL)
            && imageAddonElement.addonId === ADDON_ID_FORMULA
        ) {
            // 企业微信版插件后台需要升级新版才能支持 latex 的 sourceType
            addonType = 'latex';
        }

        // 实例化公式插件类
        const addonFormula = new Addon(
            {
                addonId: imageAddonElement.addonId,
                extraData: imageAddonElement.extraData,
                ...imageAddonElement,
            },
            addonType,
        );

        // 获取插件props数据
        const addonProps = addonFormula.getAddonProps();

        const imageSdkData = this.getImageSdkData(imageAddonElement, addonProps);

        return { selectedModel, imageSdkData };
    }

    /**
     * 文字链-->卡片态
     * @param model
     * @param linkData
     * @param textPositionInfo
     */
    private changeLinkToIframe(model, linkData, textPositionInfo, processParagraphList?: processParagraphList) {
        if (!this.canAddIframeElement() || !textPositionInfo) {
            return;
        }
        const { text, url } = linkData;

        const iframeInfo = {
            title: text,
            originUrl: url,
            embedUrl: this.iframeInfo.embedUrl,
            mode: AddonMode.IFRAME,
            aid: _has(model, 'props.addon.iframeId') ? model.props.addon.iframeId : this.iframeInfo.aid,
            extraData: _has(model, 'props.addon.extraData') ? model.props.addon.extraData : this.iframeInfo.extraData,
            width: this.iframeInfo.width,
            height: this.iframeInfo.height,
        };
        this.changeWithExtraData(model, iframeInfo, textPositionInfo, processParagraphList);
    }

    private changeWithExtraData(model, iframeInfo, textPositionInfo, processParagraphList?: processParagraphList) {
        let paragraphList: any[] = [];
        if (model.type === UIModelType.TABLE) {
            const selectRange = model.selectedRange;
            paragraphList = deepCopy(model.props.items[selectRange.rowStart][selectRange.colStart].paragraphList);
        } else {
            paragraphList = deepCopy(model.paragraphList);
        }
        // canvas 版本，一个链接可能跨 textRun 甚至跨段，没办法用旧逻辑兼容，所以在 processParagraphList 回调中处理 paragraphList
        if (processParagraphList) {
            paragraphList = processParagraphList(paragraphList);
        }
        if (model.type === UIModelType.SHAPE) {
            transaction(() => {
                // 切换为卡片态，删除文本框中链接，插入新的iframe元素
                if (this.isNeedDeleteText(model, paragraphList)) {
                    model.soruceRefForUI.deleteElement([model]);
                } else {
                    model.updateParagraphList(paragraphList);
                }
                this.insertIframeContainer(iframeInfo);
            });
        } else if (model.type === UIModelType.TABLE) {
            transaction(() => {
                model.uploadSelectedCellData({ paragraphList });
                this.insertIframeContainer(iframeInfo);
            });
        }
    }

    // 判断文本框是否需要删除
    private isNeedDeleteText = (model, paragraphList) => {
        if (model.props.subType !== 1 || !isEmptyText(model, paragraphList)) {
            // 不为文本框 || 非空
            return false;
        }
        return true;
    };

    private getNativeTitlebarManager = () => this.nativeTitleBarManager;

    /**
     * 卡片态-->文字链
     * @param model
     * @param toMode
     */
    private changeIframeToLink(model, toMode) {
        let removeProps;

        if (model.props.link) {
            removeProps = {
                link: null,
            };
        }
        if (toMode === 'icon') {
            const url = model.props.addon?.originUrl;
            if (url) {
                this.linkManager?.requestLinkData(url).then((data) => {
                    let title = url;
                    let mimeType = DEFAULT_MIMETYPE;
                    if (data && data.retcode === 0) {
                        title = data.result.linkInfo.title;
                        mimeType = data.result.linkInfo.mimeType;
                    }
                    const href = { url, mimeType, iconMode: true };
                    const updateProps = {
                        addon: {
                            displayMode: 'normal',
                        },
                    };
                    const paragraphList = [{
                        textRuns: [{
                            styles: {
                                href,
                                ['raw-href']: true,
                            },
                            text: title,
                        }],
                    }];
                    transaction(() => {
                        model.updateAndRemoveProps(updateProps, removeProps);
                        model.updateParagraphList(paragraphList);
                    });
                });
            }
            return;
        }
        const updateProps = {
            addon: {
                displayMode: toMode,
            },
        };
        model.updateAndRemoveProps(updateProps, removeProps);
    }

    private getImageSdkData = (imageAddonElement, addonProps: any): IImageSdkData => {
        const imageSize = ImageUrl.getImageSizeFromUrl(imageAddonElement.src);
        const width = imageAddonElement.width ?? imageSize.width;
        const height = imageAddonElement.height ?? imageSize.height;

        return {
            src: imageAddonElement.src,
            imageName: '',
            width,
            height,
            addon: addonProps,
        };
    };
}
